// Address Line 2 is optional; the other pickup/delivery fields are required.
export const hasMissingReturnAddressFields = (address) =>
  ["addressLine1", "city", "state", "pincode"].some(
    (field) => !String(address?.[field] ?? "").trim(),
  );

export const getOrderPickupAddress = (order) => ({
  pincode: order.shipping_address?.zip || order.billing_address?.zip,
  firstName: order.customer_first_name,
  lastName: order.customer_last_name,
  addressLine1: order.shipping_address?.address1 || order.billing_address?.address1,
  addressLine2: order.shipping_address?.address2 || order.billing_address?.address2,
  state: order.shipping_address?.province || order.billing_address?.province,
  city: order.shipping_address?.city || order.billing_address?.city,
  country: order.shipping_address?.country || order.billing_address?.country,
});
